export const announcementChannels = [
  { id: "mon-interim", label: "Mon Intérim" },
  { id: "site", label: "Le site" },
  { id: "france-travail", label: "Pôle emploi" },
  { id: "hellowork", label: "HelloWork" },
];
export const websiteChannelId = "site";
export const applicationStatuses = [
  "Nouveau",
  "Présélection",
  "Entretien tel",
  "RDV Agence",
  "Proposés Client",
  "RDV avec Client",
  "Sélectionné",
  "Recruté",
  "Refusé",
];
export function announcementApplications(announcement) {
  return (Array.isArray(announcement.candidats) ? announcement.candidats : [])
    .map((entry) => {
      const candidate =
        entry.candidateId && typeof entry.candidateId === "object"
          ? entry.candidateId
          : entry;
      return {
        ...candidate,
        _id: candidate._id || entry.candidateId,
        status: entry.status || "Nouveau",
        date: entry.date,
        source: entry.source || candidate.source,
      };
    })
    .filter((candidate) => candidate._id);
}
export function applicationPayload(announcement, candidateId, status) {
  return (announcement.candidats || []).map((entry) => {
    const id =
      typeof entry.candidateId === "object"
        ? entry.candidateId?._id
        : entry.candidateId || entry._id;
    return {
      ...entry,
      candidateId: id,
      status:
        String(id) === String(candidateId) ? status : entry.status || "Nouveau",
    };
  });
}
export function safePublicationUrl(value) {
  try {
    const url = new URL(value);
    return ["https:", "http:"].includes(url.protocol) ? url.href : "";
  } catch {
    return "";
  }
}
export function announcementText(announcement) {
  return [
    announcement.title,
    announcement.localisation || announcement.town,
    announcement.jobType,
    announcement.description,
    announcement.profilRecherche,
    announcement.salaire
      ? `Rémunération : ${announcement.salaire} ${announcement.baseSalary || ""}`
      : "",
    announcement.dateDebutSouhaitee
      ? `Début souhaité : ${announcement.dateDebutSouhaitee}`
      : "",
    announcement.tempTravail,
    announcement.informationsComplementaires,
    [announcement.email, announcement.phone].filter(Boolean).join(" · "),
  ]
    .filter(Boolean)
    .join("\n\n");
}
